import React from 'react';
import {View, ActivityIndicator, Text, StyleSheet} from 'react-native';
import {useTranslation} from 'react-i18next';

interface LaadSpinnerProps {
  message?: string;
  size?: 'small' | 'large';
}

// Even geduld a.u.b. (draaiend dingetje)
const LaadSpinner: React.FC<LaadSpinnerProps> = ({
  message,
  size = 'large',
}) => {
  const {t} = useTranslation();

  return (
    <View style={stijlen.bak}>
      <ActivityIndicator size={size} color="#7B3FF2" />
      <Text style={stijlen.bericht}>{message || t('common.loading') || 'Even geduld a.u.b...'}</Text>
    </View>
  );
};

const stijlen = StyleSheet.create({
  bak: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  bericht: {
    marginTop: 16,
    fontSize: 16,
    color: '#666',
    textAlign: 'center',
  },
});

export default LaadSpinner;
